import { useEffect } from "react";

export const useStripePricingScript = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    if (!document.querySelector('script[src*="pricing-table"]')) {
      const script = document.createElement("script");
      script.src = "https://js.stripe.com/v3/pricing-table.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, [enabled]);
};
